import React, { useMemo, useRef, useState } from 'react';
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, IconButton, InputLabel, MenuItem, Select, Stack, Tab, Tabs, TextField, Typography } from '@mui/material';
//import { getProductos } from '../../actions/productos';

import CancelIcon from '@mui/icons-material/Cancel';
//import SendIcon from '@mui/icons-material/Send'
//import SaveIcon from '@mui/icons-material/Save';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField, LocalizationProvider, TimeField } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import "dayjs/locale/es";
import { useValue } from '../../../context/ContextProvider';

const AlmacenIngresar = ({ productosOptions, proveedoresOptions, filas, setFilas, preciosEnAlmacen }) => {

    const { state: { productos } } = useValue();
    //const [productosOptions, setProductosOptions] = useState([])
    const [productState, setProductState] = useState(null)

    const codigoBarrasRef = useRef();
    const shortcutRef = useRef();
    //const productRef = useRef();
    //const nombreMarcaRef = useRef();
    //const nombreCategoriaRef = useRef();
    const cantidadRef = useRef();
    const costoRef = useRef();
    const precioRef = useRef();
    const descRef = useRef();
    const obsRef = useRef();
    const habRef = useRef();
    const vencimientoRef = useRef();
    const proveedorRef = useRef();
    //const [habCheck, setHabCheck] = useState(true);
    const [codigoBarrasState, setCodigoBarrasState] = useState('')
    const [shortcutState, setShortcutState] = useState('')
    const [tipoState, setTipoState] = useState('')
    //const [productoState, setProductoState] = useState('')
    const [proveedorState, setProveedorState] = useState('')
    //const [costoState, setCostoState] = useState(0)
    //const [precioState, setPrecioState] = useState(0)
    const [marcaState, setMarcaState] = useState('')
    const [categoriaState, setCategoriaState] = useState('')

    //const [filas, setFilas] = useState([])
    const [idSerial, setIdSerial] = useState(1)


    const [costo, setCosto] = useState("0.00");
    const [precio, setPrecio] = useState("0.00");
    const [cantidad, setCantidad] = useState("0");

    const [ubicacionState, setUbicacionState] = useState('Almacen');

    //const proveedorOptions = [{ id: 1, label: 'Panadería Barrio Lindo' }, { id: 2, label: 'Marco Polo' }, { id: 3, label: 'Condorito' }]


    const handleSubmitIngresar = (event) => {
        event.preventDefault();
    }

    const handleCloseIngresar = () => {

    }

    const llenarDatosExtra = (product) => {
        //console.log({ preciosEnAlmacen })
        const datosExtra = preciosEnAlmacen.find((item) => item.product == product);
        //console.log({ datosExtra })
        if (datosExtra) {
            const { cost: costoLocal, price: precioLocal, supplier: proveedorLocal } = datosExtra;
            //console.log({ costoLocal, precioLocal, proveedorLocal, proveedoresOptions })
            const proveedorLabel = proveedoresOptions?.find((item) => item.id == proveedorLocal)?.label;
            //console.log('proveedor', proveedorLabel);
            setCosto(costoLocal);
            setPrecio(precioLocal);
            if(proveedorLabel){
                setProveedorState(proveedorLabel);
            } else {
                setProveedorState('');
                proveedorRef.current.focus()
            }
        } else {
            setCosto('0.00');
            setPrecio('0.00');
            setProveedorState('');
            proveedorRef.current.focus();
        }
        setCantidad(0);
    }

    const handleCodigoBarrasBlur = (event) => {
        //event.preventDefault();
        if (codigoBarrasState != "") {
            //console.log('Cod Bar Text: ', codigoBarrasState);
            //console.log({productos});
            const productoEncontrado = productos.find((producto) => producto.codBar == codigoBarrasState);
            //console.log({ productoEncontrado });
            if (productoEncontrado) {
                //codigoBarrasRef.current.value = "";
                setCodigoBarrasState(productoEncontrado.codBar);
                setShortcutState(productoEncontrado.scut);
                setProductState(productoEncontrado.product);
                setTipoState(productoEncontrado.type);
                setMarcaState(productoEncontrado.brand);
                setCategoriaState(productoEncontrado.category);

                llenarDatosExtra(productoEncontrado.product);

            } else {
                setCodigoBarrasState("");
                setShortcutState("");
                setProductState("");
                setTipoState("");
                setMarcaState("");
                setCategoriaState("");
                setProveedorState("");
                codigoBarrasRef.current.focus();
            }
        }
    }

    const handleShortcutBlur = (event) => {
        //event.preventDefault();
        if (shortcutState != "") {
            //console.log('Cod Bar Text: ', codigoBarrasState);
            const productoEncontrado = productos.find((producto) => producto.scut == shortcutState);
            //console.log({ productoEncontrado });
            if (productoEncontrado) {
                //codigoBarrasRef.current.value = "";
                setCodigoBarrasState(productoEncontrado.codBar);
                setShortcutState(productoEncontrado.scut);
                setProductState(productoEncontrado.product);
                setTipoState(productoEncontrado.type);
                setMarcaState(productoEncontrado.brand);
                setCategoriaState(productoEncontrado.category);

                llenarDatosExtra(productoEncontrado.product);

            } else {
                setCodigoBarrasState("");
                setShortcutState("");
                setProductState("");
                setTipoState("");
                setMarcaState("");
                setCategoriaState("");
                setProveedorState("");
                codigoBarrasRef.current.focus();
            }
        }
    }

    const handleProductoChange = (event, value, reason) => {
        //console.log({ event, value, reason });
        setProductState(event.currentTarget.textContent);
        if (reason == 'selectOption') {
            //console.log('Opcion seleccionada');
            const productoEncontrado = productos.find((producto) => producto.id == value.id);
            //console.log({ productoEncontrado });
            if (productoEncontrado) {
                setCodigoBarrasState(productoEncontrado.codBar);
                setShortcutState(productoEncontrado.scut);
                setProductState(productoEncontrado.product);
                setTipoState(productoEncontrado.type);
                setMarcaState(productoEncontrado.brand);
                setCategoriaState(productoEncontrado.category);
                //cantidadRef.current.focus();
                llenarDatosExtra(productoEncontrado.product);
            } else {
                setCodigoBarrasState("");
                setShortcutState("");
                setProductState("");
                setTipoState("");
                setMarcaState("");
                setCategoriaState("");
                setProveedorState("");
            }
        }
    }

    const handleLog = () => {
        //console.log({ productos, productosOptions, contextLoading });
        console.log({ proveedorState })
    }

    const handleCodigoBarrasEnter = () => {
        cantidadRef.current.focus();     //Pasa focus a otro elemento
    }

    const handleUbicacionChange = (event) => {
        setUbicacionState(event.target.value);
    };

    //let idSerial = 0;

    const handleAddProduct = () => {
        const multiplicacion = (cantidad * costo).toFixed(2);
        //console.log({proveedorState, productState})
        setIdSerial(idSerial + 1)

        const proveedor = proveedoresOptions.find((p) => p.label == proveedorState);

        let ubicacion = ubicacionState;

        if(tipoState == 'Pan') {
            ubicacion = 'Tienda';
        }
        
        const newRow = {
            id: idSerial,
            codBar: codigoBarrasState,
            product: productState,
            tipo: tipoState,
            cantidad,
            costo,
            precio,
            total: multiplicacion,
            observaciones: obsRef.current.value,
            vencimiento: vencimientoRef.current.value,
            ubicacion,
            proveedor: proveedorState,
            proveedorId: proveedor?.id,
        }

        if (cantidad <= 0) {
            //console.log('Por favor revise la cantidad introducida.');
            cantidadRef.current.focus();
            return;
        }

        if (costo <= 0) {
            //console.log('Por favor revise el costo introducido.');
            costoRef.current.focus();
            return;
        }

        if (precio <= 0) {
            //console.log('Por favor revise el precio introducido.');
            precioRef.current.focus();
            return;
        }

        if (proveedorState == '') {
            //console.log('Seleccione un proveedor');
            //console.log(proveedorRef.current.value);
            proveedorRef.current.focus();
            return;
        }

        if (filas.find((fila) => fila.product === productState)) {
            //console.log('Producto duplicado');
        } else {
            //console.log({newRow});
            setFilas([...filas, newRow]);
            //console.log({filas});
            setCantidad(0);
            setCosto(0);
            setPrecio(0);
            obsRef.current.value = "";
            setCodigoBarrasState("");
            setShortcutState("");
            setProductState("");
            setTipoState("");
            setMarcaState("");
            setCategoriaState("");
            setProveedorState("");
            codigoBarrasRef.current.focus();
        }
    }




    return (
        <Box>
            <form onSubmit={(event) => handleSubmitIngresar(event)}>
                <Stack direction='row' spacing={2} paddingBottom={3}>
                    <TextField
                        autoFocus={true}
                        autoComplete='off'      //Para que no salga opciones de texto anteriores
                        margin='normal'
                        variant='outlined'
                        id='codigoBarras'
                        label='Código de Barras'
                        type='text'
                        fullWidth
                        inputRef={codigoBarrasRef}
                        value={codigoBarrasState}
                        //inputProps={{ minLength: 8 }}
                        onBlur={(event) => handleCodigoBarrasBlur(event)}   //Función cuando pierde el focus
                        onChange={(event) => setCodigoBarrasState(event.target.value)}
                        onFocus={event => event.target.select()}
                        inputProps={{
                            onKeyPress: event => {          //Para gestionar enter
                                const { key } = event;
                                ////console.log(key);
                                if (key === "Enter") {
                                    handleCodigoBarrasEnter();
                                    //habRef.current.focus();     //Pasa focus a otro elemento
                                }
                            },
                            minLength: 8
                        }}
                    //required
                    />

                    <TextField                  //Para introducir el shortcut
                        autoComplete='off'      //Para que no salga opciones de texto anteriores
                        margin='normal'
                        variant='outlined'
                        id='shortcut'
                        label='Shortcut'
                        type='text'
                        inputRef={shortcutRef}
                        value={shortcutState}
                        //inputProps={{ minLength: 8 }}
                        onBlur={(event) => handleShortcutBlur(event)}   //Función cuando pierde el focus
                        onChange={(event) => setShortcutState(event.target.value)}
                        onFocus={event => event.target.select()}
                        inputProps={{
                            onKeyPress: event => {          //Para gestionar enter
                                const { key } = event;
                                ////console.log(key);
                                if (key === "Enter") {
                                    handleCodigoBarrasEnter();
                                    //habRef.current.focus();     //Pasa focus a otro elemento
                                }
                            },
                            //minLength: 8
                        }}
                    //required
                    />
                </Stack>

                <Stack direction='row' spacing={2} paddingBottom={3}>
                    <Autocomplete
                        disablePortal={false}
                        id="combo-box-demo"
                        options={productosOptions}
                        fullWidth
                        renderInput={(params) => <TextField {...params} label="Producto" />}
                        ListboxProps={{ style: { maxHeight: 150 } }}
                        //inputRef={productoRef}
                        //defaultValue={isUpdate ? rowOriginal?.nombreCategoria : ''}
                        value={productState}
                        onChange={(event, value, reason) => handleProductoChange(event, value, reason)}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        required
                    />
                    <TextField
                        margin='normal'
                        variant='outlined'
                        id='tipo'
                        label='Tipo'
                        type='text'
                        
                        //inputRef={nombreMarcaRef}
                        value={tipoState}
                        disabled
                    />
                </Stack>

                <Stack direction='row' spacing={2} paddingBottom={3}>
                    <Autocomplete
                        disablePortal={false}   //Para que la caja de opciones salga siempre abajo
                        id="combo-box-proveedor"
                        options={proveedoresOptions}
                        fullWidth
                        renderInput={(params) => <TextField {...params} label="Proveedor" inputRef={proveedorRef} />}
                        //renderInput={(params) => <TextField {...params} label="Proveedor" />}
                        ListboxProps={{ style: { maxHeight: 150 } }}
                        //inputRef={proveedorRef}
                        //defaultValue={isUpdate ? rowOriginal?.nombreCategoria : ''}
                        value={proveedorState}
                        onChange={(event) => setProveedorState(event.target.textContent)}
                        //onChange={(event, value, reason) => handleProveedorChange(event, value, reason)}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        required
                    />
                </Stack>

                <Stack direction='row' spacing={2} paddingBottom={3}>
                    <TextField
                        margin='normal'
                        variant='outlined'
                        id='marca'
                        label='Marca'
                        type='text'
                        fullWidth
                        //inputRef={nombreMarcaRef}
                        value={marcaState}
                        disabled
                    />

                    <TextField
                        margin='normal'
                        variant='outlined'
                        id='categoria'
                        label='Categoria'
                        type='text'
                        fullWidth
                        //inputRef={nombreCategoriaRef}
                        value={categoriaState}
                        enable='false'
                        disabled
                    />
                </Stack>

                <Stack direction='row' spacing={2} paddingBottom={3}>
                    <TextField
                        type="number"
                        label='Costo'
                        value={costo}
                        variant="outlined"
                        inputRef={costoRef}
                        inputProps={{
                            maxLength: 7,
                            step: "0.5",
                        }}
                        onChange={(e) => setCosto(e.target.value ? parseFloat(e.target.value) : 0.00)}
                        onFocus={event => event.target.select()}
                        onBlur={(e) => { setCosto(e.target.value ? parseFloat(e.target.value).toFixed(2) : 0.00) }}
                    />

                    <TextField
                        type="number"
                        label='Precio'
                        value={precio}
                        variant="outlined"
                        inputRef={precioRef}
                        inputProps={{
                            maxLength: 7,
                            step: "0.5",
                        }}
                        onChange={(e) => setPrecio(e.target.value ? parseFloat(e.target.value) : 0.00)}
                        onFocus={event => event.target.select()}
                        onBlur={(e) => { setPrecio(e.target.value ? parseFloat(e.target.value).toFixed(2) : 0.00) }}
                    />

                    <TextField
                        type="number"
                        label='Cantidad'
                        value={cantidad}
                        variant="outlined"
                        inputRef={cantidadRef}
                        inputProps={{
                            maxLength: 5,
                            step: "1",
                        }}
                        onFocus={event => event.target.select()}
                        //onChange={(e) => setCantidad(e.target.value ? parseInt(e.target.value) : 0)}
                        onChange={(e) => setCantidad(e.target.value ? (e.target.value).replace(/^0+|[.]/, "") : 0)}
                        onBlur={(e) => setCantidad(e.target.value ? parseInt(e.target.value, 10) : 0)}
                    />




                </Stack>



                <Stack direction='row' spacing={2} paddingBottom={3}>


                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="es"
                    >
                        <DatePicker
                            label="Fecha de vencimiento"
                            format="YYYY/MM/DD"
                            inputRef={vencimientoRef}
                            defaultValue={dayjs('2024/02/20')}
                        />

                    </LocalizationProvider>

                    <FormControl style={{ minWidth: '50%', maxWidth: 300, }}>
                        <InputLabel id="ubicacion-label">Destino</InputLabel>
                        <Select
                            labelId="ubicacion-select-label"
                            id="ubicacion-simple-select"
                            value={tipoState=='Pan' ? 'Tienda' : ubicacionState }
                            label="Ubicación"
                            onChange={handleUbicacionChange}
                            disabled = {tipoState == 'Pan'}
                        >
                            <MenuItem value={'Almacen'}>Almacen</MenuItem>
                            <MenuItem value={'Tienda'}>Tienda</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>

                <Stack direction='row' spacing={2} paddingBottom={2} justifyContent='end'>
                    <TextField
                        margin='normal'
                        variant='outlined'
                        id='obs'
                        type='text'
                        label='Observaciones'
                        fullWidth
                        inputRef={obsRef}
                        //inputProps={{ minLength: 6 }}
                        multiline
                        rows={2}
                    //defaultValue={isUpdate ? rowOriginal?.descripcion : ''}
                    //required
                    />
                </Stack>


                <Stack direction='row' spacing={2} justifyContent='end'>

                    <Button onClick={handleLog} variant="outlined" startIcon={<CancelIcon />}>
                        Cancelar
                    </Button>
                    <Button onClick={handleAddProduct} type='submit' variant='contained' startIcon={<PlaylistAddIcon />}>
                        Agregar a la lista
                    </Button>
                </Stack>
            </form >
        </Box>
    )
}

export default AlmacenIngresar